import React from 'react';
import { Add } from '@mui/icons-material';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import AdminSurface from '../../../../components/admin/AdminSurface';
import { adminColors, adminTypography } from '../../../../styles/adminDesignTokens';
import {
  adminButtonSx,
  adminButtonToneSx,
  adminCombineSx,
  adminEmptyStateSx,
} from '../../../../styles/adminComponentStyles';

interface StateGamesStatusProps {
  mode: 'invalid' | 'loading' | 'empty';
  statesLoading?: boolean;
  onCreateGame?: () => void;
}

const StateGamesStatus: React.FC<StateGamesStatusProps> = ({ mode, statesLoading = false, onCreateGame }) => {
  if (mode === 'invalid') {
    return (
      <AdminSurface sx={{ p: 3, textAlign: 'center' }}>
        {statesLoading ? (
          <CircularProgress size={28} />
        ) : (
          <>
            <Typography sx={{ ...adminTypography.cardTitle, color: adminColors.text, mb: 0.5 }}>
              State not found
            </Typography>
            <Typography sx={{ ...adminTypography.body, color: adminColors.mutedText }}>
              We could not find details for the requested state. Please pick another one from the locations list.
            </Typography>
          </>
        )}
      </AdminSurface>
    );
  }

  if (mode === 'loading') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  return (
    <Box sx={adminEmptyStateSx}>
      <Typography className="AdminEmptyState-title">
        No Games Found
      </Typography>
      <Typography className="AdminEmptyState-copy">
        No games found for the selected state. Get started by creating your first lottery game.
      </Typography>
      <Button
        variant="contained"
        onClick={onCreateGame}
        startIcon={<Add />}
        size="small"
        sx={adminCombineSx(adminButtonSx, adminButtonToneSx.primary)}
      >
        Create Your First Game
      </Button>
    </Box>
  );
};

export default React.memo(StateGamesStatus);
